import { debounce as debouncer } from '@/helpers/debounce'

const DEFAULT_DELAY = 500

export const debounce = {
  methods: {
    debounce: debouncer(func => func(), DEFAULT_DELAY)
  }
}
